import React from 'react';

const Filter = props => {
  const resetForm = e => {
    e.preventDefault();
    props.clearForm();
  };

  return (
    <div className="card">
      <div className="card-header">{locales('titles.filter')}</div>
      <div className="card-body">
        <form
          onSubmit={e => {
            e.preventDefault();
            props.applyFilters(e);
          }}
        >
          <h6 className="d-flex col-12">{locales('titles.search')}</h6>

          <div className="col-12">
            <input
              onChange={props.onChangeCafeName}
              onKeyPress={e => e.key === 'Enter' && e.preventDefault()}
              value={props.cafeName}
              autoComplete="off"
              name="cafeNamePart"
              type="text"
              className="form-control m-2 col-6 h-50 py-2"
              placeholder={locales('fields.cafe.name')}
            />
            <div className="col-12 d-flex justify-content-end my-3">
              <button onClick={resetForm} className="mx-1 btn btn-danger">
                {locales('fields.reset')}
              </button>
              <button type="submit" className="mx-1 btn btn-success">
                {locales('fields.applyFilters')}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Filter;
